import { render } from "./UploadAgentSimplified.vue?vue&type=template&id=1172f01e&scoped=true"
import script from "./UploadAgentSimplified.vue?vue&type=script&lang=js"
export * from "./UploadAgentSimplified.vue?vue&type=script&lang=js"

import "./UploadAgentSimplified.vue?vue&type=style&index=0&id=1172f01e&scoped=true&lang=css"

import exportComponent from "D:\\Projects\\JCXS\\CAAMSNG\\frontend-caams\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1172f01e"]])

export default __exports__